module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-post-fill-dfb624f4.svg";